import angular from 'angular';
import captchaWithFallback from './captcha-with-fallback.component';

let captchaWithFallbackModule = angular.module('captcha-with-fallback', [])

.component('captchaWithFallback', captchaWithFallback)

.name;

export default captchaWithFallbackModule;



// WEBPACK FOOTER //
// ./client/app/common/captcha-with-fallback/captcha-with-fallback.js